import { isObject } from '../TypeHelpers';
import equivilentToByJSON from './equivilentToByJSON';
export default function equals(obj1, obj2, forceJSON = false, deep = false) {
    let state = false;
    if (isObject(obj1)) {
        if (!forceJSON) {
            for (const key in Object.getOwnPropertyNames(obj1)) {
                if (deep) {
                    state = equals(obj1[key], obj2[key], forceJSON, deep);
                }
                else {
                    state = obj1[key] == obj2[key];
                }
                if (!state) {
                    break;
                }
            }
        }
        else {
            state = equivilentToByJSON(obj1, obj2);
        }
    }
    else {
        state = forceJSON
            ? equivilentToByJSON(obj1, obj2)
            : obj1 === obj2;
    }
    return state;
}
